import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { mapActions } from "vuex";
import { BULK_DELETE_CLIENTS, LOAD_PAGINATED_DRIP_CAMPAIGN_CLIENTS } from "../../store/drip-campaign-actions";
import { debounce, pickBy, some } from "lodash";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
const NEVER_FETCHED = -1;
const MAX_COUNT = 9999999;
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignClientsTable",
  components: {
    InlinePrompt,
    SimpleButton
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      lastTableFetchLength: NEVER_FETCHED,
      searchString: "",
      clientsMarkedForDeletion: {},
      bulkDeleteLoading: {
        loading: false,
        loadingSucceeded: true
      }
    };
  },
  computed: {
    tableOptions() {
      return {
        columns: ["selected", "name", "email", "stage", "active"],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            selected: "nodisplay",
            name: this.$t("account.name"),
            email: this.$t("account.email"),
            stage: this.$t("drip-campaigns.stage"),
            active: this.$t("drip-campaigns.active")
          },
          perPage: 20,
          tabbable: false,
          skin: "table mb-0",
          texts: {
            noResults: this.$t("boards.messages.emptyClients")
          },
          requestFunction: this.tableRequestFunction.bind(this),
          stickyHeader: true,
          pagination: {
            virtual: true
          }
        }
      };
    },
    anyClientSelected() {
      return some(this.clientsMarkedForDeletion, value => value);
    }
  },
  watch: {
    loading(val) {
      this.$emit("loading", val);
    },
    searchString: debounce(function () {
      this.refreshData();
    }, 200)
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [LOAD_PAGINATED_DRIP_CAMPAIGN_CLIENTS, BULK_DELETE_CLIENTS])), {}, {
    handleDeleteClient(clientProfileId) {
      this.$emit("delete-client", clientProfileId);
    },
    refreshData() {
      this.$set(this, "clientsMarkedForDeletion", {});
      this.lastTableFetchLength = NEVER_FETCHED;
      this.$refs.table.refresh();
    },
    async tableRequestFunction(tableOptions) {
      var _this$searchString;
      const tableData = {
        data: [],
        count: MAX_COUNT
      };

      // since the backend :) is not sending how many rows are in total
      // we need to have a way to tell the table to stop fetching more data
      // so if the last fetch was empty, there is likely no more records to fetch
      if (this.lastTableFetchLength === 0) return tableData;
      const {
        page,
        limit
      } = tableOptions;
      const offset = (page - 1) * limit;
      const data = await this.LOAD_PAGINATED_DRIP_CAMPAIGN_CLIENTS({
        campaignId: this.campaignId,
        paginationData: {
          offset,
          limit,
          searchString: (_this$searchString = this.searchString) == null ? void 0 : _this$searchString.toLowerCase()
        }
      });
      this.lastTableFetchLength = data.length;
      tableData.data = data;
      return tableData;
    },
    handleTableLoading() {
      this.loading = true;
    },
    handleTableLoaded() {
      this.loading = false;
    },
    async handleBulkDelete() {
      if (!this.anyClientSelected || this.bulkDeleteLoading.loading) return;
      try {
        this.bulkDeleteLoading.loading = true;
        this.bulkDeleteLoading.loadingSucceeded = true;
        const clientsMarkedForDeletion = _Object$keys(pickBy(this.clientsMarkedForDeletion, value => value));
        await this.BULK_DELETE_CLIENTS({
          campaignId: this.campaignId,
          clientProfileIds: clientsMarkedForDeletion
        });
        this.refreshData();
        this.$emit("clients-deleted");
      } catch (_unused) {
        this.bulkDeleteLoading.loadingSucceeded = false;
      } finally {
        this.bulkDeleteLoading.loading = false;
      }
    }
  })
});